<div class="popover-container">
  <ng-template #popoverContent>
    <div cdkTrapFocus role="dialog" aria-labelledby="controlPopoverTitle" >
      <div class="panel-header" >
        <span id="controlPopoverTitle" class="popover-title">{{ title }}</span>
        <zbp-button-component
          id="closePopoverButton"
          type="button"
          theme="transparentWhite"
          class="panel-close"
          (click)="closePopover()"
          [iconName]="zbpIconNames.x_cross"
          iconPrimaryColor="var(--viewer-text-muted-light-grey)"
          [ariaLabel]="'Close'">
        </zbp-button-component>
      </div>
      <div class="body">
        <ng-content></ng-content>
      </div>
    </div>
  </ng-template>
</div>
